import * as React from 'react';
import { Container, Grid, Spacer } from '@nextui-org/react';

import { useSession } from 'next-auth/react';
import { AppUnauthorized } from '@src/layouts/app/AppUnauthorized';
import { AddUser } from '@src/layouts/users/AddUser';
import { UsersList } from '@src/layouts/users/UsersList';

interface UsersPageProps {}

/**
 * @name UsersPage
 * @description The UsersPage page.
 */
export default function UsersPage(_props: UsersPageProps) {
  // const { } = props;

  // Hooks
  const { status } = useSession();

  if (status === 'unauthenticated') {
    return <AppUnauthorized />;
  }

  return (
    <Container sm css={{ p: 0 }}>
      <Spacer y={1} />
      <Grid.Container gap={2} css={{ p: 0 }}>
        <Grid xs={12}>
          <AddUser />
        </Grid>
        <Grid xs={12}>
          <UsersList />
        </Grid>
      </Grid.Container>
    </Container>
  );
}
